module.exports = __webpack_public_path__ + "static/media/faccebook.d24d1b3c.svg";